import AbstractGroupItem from './abstractGroupItem';

/**
 * @class GroupItem
 * @extends AbstractGroupItem
 */
const GroupItem = AbstractGroupItem.extend({

    /**
     * Item type
     *
     * @property {String} type
     */
    type: 'group',

    defaults: {
        ...AbstractGroupItem.prototype.defaults,

        /**
         * @property {String} Type
         */
        type: 'Group',
    },
});

export default GroupItem;
